// extracted by mini-css-extract-plugin
export var container = "_ea-0";
export var icon = "_ea-1";
export var text = "_ea-2";